import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/screen/feed/view/home/index.tsx");
